// src/components/ScrollToTop.jsx - Component to handle scroll to top on route changes
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // No animation for immediate scroll
    });
  }, [pathname]);

  return children || null;
};

export default ScrollToTop;